module.exports = __webpack_public_path__ + "static/img/verify-email.615e727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/verify-email.jpg
// module id = 706
// module chunks = 21